import { render, staticRenderFns } from "./common-img.vue?vue&type=template&id=0496e480&scoped=true&"
import script from "./common-img.vue?vue&type=script&lang=ts&"
export * from "./common-img.vue?vue&type=script&lang=ts&"
import style0 from "./common-img.vue?vue&type=style&index=0&id=0496e480&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0496e480",
  null
  
)

export default component.exports